import { Link } from 'react-router-dom';

export default function ForNodesPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-essence-teal">
        For Self OS nodes
      </p>
      <h1 className="mt-3 max-w-3xl font-display text-4xl font-bold tracking-tight text-essence-ink sm:text-5xl">
        Idle phone compute earns Essence
      </h1>
      <p className="mt-5 max-w-2xl text-lg leading-relaxed text-essence-mute">
        Self OS phones that contribute verified idle compute to Resonatia earn Essence on a cloud ledger first.
        Phones do not mint on-chain. In the SELF OS design, Resonatia turns devices into compute participants and
        Essence is the compensation rail — resources, quality, availability, demand.
      </p>

      <div className="mt-14 grid gap-8 lg:grid-cols-3">
        {[
          {
            phase: 'Live',
            title: 'Cloud ledger',
            body: 'Verified work credits your Essence balance off-chain. This is the source of truth until withdraw opens.',
          },
          {
            phase: 'Live (beta)',
            title: 'Talk credits',
            body: 'Convert Essence → Concierge Talk credits in Self Shell beta — capped human redemption path.',
          },
          {
            phase: 'Next',
            title: 'On-chain withdraw',
            body: 'When EssenceTreasury holds USDC, Concierge-signed withdraw mints ESSENCE via EssenceBridge.',
          },
        ].map((item) => (
          <div key={item.title} className="border-t border-essence-line pt-5">
            <p className="text-xs font-semibold uppercase tracking-wider text-essence-gold">{item.phase}</p>
            <h2 className="mt-2 font-display text-xl font-semibold text-essence-ink">{item.title}</h2>
            <p className="mt-2 text-sm leading-relaxed text-essence-mute">{item.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-14 max-w-2xl border-l-2 border-essence-teal/60 pl-5">
        <h2 className="font-display text-xl font-semibold text-essence-ink">Later redemptions</h2>
        <p className="mt-2 text-base leading-relaxed text-essence-mute">
          Deposit / burn ESSENCE to redeem USDC when the treasury loop is funded. Not available yet — and never
          marketed as guaranteed yield or risk-free cash.
        </p>
      </div>

      <div className="mt-12 flex flex-wrap gap-3">
        <Link
          to={{ pathname: '/', hash: 'get-the-app' }}
          className="inline-flex rounded-lg bg-essence-teal px-5 py-3 text-sm font-semibold text-white hover:bg-essence-teal-bright"
        >
          Download Self OS beta
        </Link>
        <Link
          to="/how-it-works"
          className="inline-flex rounded-lg border border-essence-line px-5 py-3 text-sm font-semibold text-essence-ink hover:border-essence-gold/40"
        >
          Economic loop
        </Link>
        <Link
          to="/for-agents"
          className="inline-flex rounded-lg border border-essence-line px-5 py-3 text-sm font-semibold text-essence-ink hover:border-essence-gold/40"
        >
          For agents
        </Link>
      </div>
    </div>
  );
}
